/* "Kombinini Tamamla" (snippets/complete-look.liquid) — numara seçimi, tek tek ve
   toplu sepete ekleme. Leyuze AI'dan bağımsız. Stok kontrolünü Shopify yapar:
   /cart/add.js stokta olmayan varyantı reddeder (422); o durumda müşteriye
   sayfayı yenilemesi söylenir. Toplu ekleme elbiseyle birliktedir: ürün
   formunda elbise bedeni seçilmeden hiçbir parça eklenmez. */
(function () {
  'use strict';
  var root = document.querySelector('[data-look]');
  if (!root || !window.fetch) return;
  var d = root.dataset;
  var items = [].slice.call(root.querySelectorAll('[data-look-item]'));
  var allBtn = root.querySelector('[data-look-all]');
  var allMsg = root.querySelector('[data-look-all-msg]');
  var hint = root.querySelector('[data-look-hint]');
  var form = document.getElementById('product-form');

  function fmt(s, v) { return s.replace('%s', v); }
  function line(card) {
    var props = {};
    if (card.dataset.color && d.colorKey) props[d.colorKey] = card.dataset.color;
    return { id: Number(card.dataset.variant), quantity: 1, properties: props };
  }
  function dressLine() {
    if (!form) return null;
    var id = form.querySelector('[data-variant-id]');
    if (!id || !id.value) return null;
    var props = {};
    var c = form.querySelector('[data-color-property]');
    if (c && c.value) props[c.name.replace(/^properties\[(.*)\]$/, '$1')] = c.value;
    return { id: Number(id.value), quantity: 1, properties: props };
  }
  function dressSize() {
    var l = dressLine();
    if (!l) return null;
    try {
      var vs = JSON.parse((document.querySelector('[data-product-json]') || {}).textContent || '[]');
      var v = vs.filter(function (x) { return Number(x.id) === l.id; })[0];
      return v ? v.title : '';
    } catch (e) { return ''; }
  }
  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    document.querySelectorAll('[data-cart-badge]').forEach(function (el) { el.textContent = count > 99 ? '99+' : count; el.hidden = count === 0; });
  }
  function done(msgEl) {
    msgEl.textContent = d.tAdded + ' ';
    var a = document.createElement('a');
    a.href = d.cartUrl; a.className = 'u-link'; a.textContent = d.tGo;
    msgEl.appendChild(a);
    fetch(d.cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
  }
  function add(lines, btn, msgEl) {
    btn.disabled = true; msgEl.textContent = '';
    return fetch(d.cartAddUrl, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      done(msgEl);
    }).catch(function () {
      msgEl.textContent = d.tFail;
      fetch(d.cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
    }).then(function () { btn.disabled = false; refresh(); });
  }

  function refresh() {
    var on = items.filter(function (c) { return c.querySelector('[data-look-include]').checked; });
    var missing = on.filter(function (c) { return !c.dataset.variant; });
    var dress = dressSize();
    // Tek satır yardım: önce elbise bedeni, sonra eksik numara, en son ne ekleneceği
    hint.textContent = dress === null ? d.tDressOut
      : missing.length ? fmt(d.tNeed, missing.map(function (c) { return c.dataset.kind; }).join(', ')) + '.'
      : fmt(d.tDressIn, dress);
    if (dress !== null) hint.classList.remove('is-alert');
    var n = on.length + (dress !== null ? 1 : 0);
    allBtn.textContent = allBtn.dataset.label + (n ? ' (' + n + ')' : '');
    allBtn.disabled = !on.length;
    items.forEach(function (c) { c.classList.toggle('is-off', !c.querySelector('[data-look-include]').checked); });
  }

  items.forEach(function (card) {
    var btn = card.querySelector('[data-look-add]');
    var msg = card.querySelector('[data-look-msg]');
    var sel = card.querySelector('[data-look-select]');
    if (sel) sel.addEventListener('change', function () {
      card.dataset.variant = sel.value;
      btn.disabled = !sel.value; btn.textContent = allBtn.dataset.addLabel;
      refresh();
    });
    card.querySelector('[data-look-include]').addEventListener('change', refresh);
    btn.addEventListener('click', function () { if (card.dataset.variant) add([line(card)], btn, msg); });
  });

  allBtn.addEventListener('click', function () {
    // Kombin elbiseyle birlikte eklenir: elbise bedeni seçilmeden hiçbir şey eklenmez,
    // müşteri ürün formundaki beden seçimine götürülür
    var dl = dressLine();
    if (!dl) {
      hint.classList.add('is-alert');
      if (form) {
        var sizes = form.querySelector('.option__values') || form;
        var top = sizes.getBoundingClientRect().top + window.pageYOffset - window.innerHeight / 3;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        var first = sizes.querySelector('input[type=radio]:not(:disabled)');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
      }
      return;
    }
    var on = items.filter(function (c) { return c.querySelector('[data-look-include]').checked; });
    var missing = on.filter(function (c) { return !c.dataset.variant; });
    if (!on.length) return;
    if (missing.length) { allMsg.textContent = fmt(d.tNeed, missing.map(function (c) { return c.dataset.kind; }).join(', ')) + '.'; return; }
    var lines = on.map(line);
    lines.unshift(dl);
    add(lines, allBtn, allMsg);
  });

  // Elbise bedeni ürün formunda değişince toplu düğmenin metni güncellensin
  if (form) {
    var idInput = form.querySelector('[data-variant-id]');
    form.addEventListener('change', function () { setTimeout(refresh, 0); });
    form.addEventListener('click', function () { setTimeout(refresh, 0); });
    if (idInput && window.MutationObserver) new MutationObserver(refresh).observe(idInput, { attributes: true });
  }
  refresh();
})();
